import { services } from '@widget/config/redirects';

import type { ZipCodeType } from './types';
import type { QueryFunctionContext } from '@tanstack/react-query';

export const ZipCodesQueryKey = {
  all: ['zipcodes'] as const,
  getByMarket(market: string) {
    return [...ZipCodesQueryKey.all, market] as const;
  },
};

export const ZipCodesQueryFn = {
  async getByMarket({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof ZipCodesQueryKey.getByMarket>>) {
    const response = await fetch(`${services.webApp}/api/${queryKey[0]}?market=${queryKey[1]}`);
    if (!response.ok) {
      throw new Error('Zipcodes request failed');
    }

    return (await response.json()) as ZipCodeType[];
  },
};
